import(/* webpackMode: "eager" */ "/home/runner/work/product-frontend/product-frontend/app/error.tsx");
